import { render, staticRenderFns } from "./Template225.vue?vue&type=template&id=468143ad"
import script from "./Template225.vue?vue&type=script&lang=js"
export * from "./Template225.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports